var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collectionmainlist"},[_c('collection-list',{attrs:{"collections":_vm.items,"loading":_vm.loading,"total-items":_vm.totalItems,"per-page":_vm.perPage,"root-margin":"400px 0px"},on:{"page-change":_vm._onPageChange,"on-search":_vm.onSearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }